var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojisIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.53846C7.32682 3.53846 3.53846 7.32682 3.53846 12C3.53846 16.6732 7.32682 20.4615 12 20.4615C16.6732 20.4615 20.4615 16.6732 20.4615 12C20.4615 7.32682 16.6732 3.53846 12 3.53846ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8.15385 9.94872C8.15385 9.52388 8.49824 9.17949 8.92308 9.17949H8.93333C9.35817 9.17949 9.70256 9.52388 9.70256 9.94872C9.70256 10.3736 9.35817 10.7179 8.93333 10.7179H8.92308C8.49824 10.7179 8.15385 10.3736 8.15385 9.94872ZM14.3077 9.94872C14.3077 9.52388 14.6521 9.17949 15.0769 9.17949H15.0872C15.512 9.17949 15.8564 9.52388 15.8564 9.94872C15.8564 10.3736 15.512 10.7179 15.0872 10.7179H15.0769C14.6521 10.7179 14.3077 10.3736 14.3077 9.94872ZM8.55512 14.357C8.85552 14.0566 9.34257 14.0566 9.64298 14.357C10.9447 15.6588 13.0553 15.6588 14.357 14.357C14.6574 14.0566 15.1445 14.0566 15.4449 14.357C15.7453 14.6574 15.7453 15.1445 15.4449 15.4449C13.5423 17.3474 10.4577 17.3474 8.55512 15.4449C8.25472 15.1445 8.25472 14.6574 8.55512 14.357Z",
    fill: "#A5A9B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojisIcon);
export default __webpack_public_path__ + "static/media/emojis-icon.7f90f8ef48274742866cdeab2730f3e4.svg";
export { ForwardRef as ReactComponent };